<template>
  <section class="container member-layout" :class="{ 'member-layout-wallet': hasRightRail }">
    <aside class="member-sidebar" aria-label="会员中心导航">
      <div class="member-sidebar-profile">
        <button class="member-sidebar-avatar" aria-label="查看个人资料" @click="navigate('/member')">
          <img v-if="memberAvatarUrl" :src="memberAvatarUrl" alt="个人头像" />
          <span v-else>{{ userName?.slice(0, 1).toUpperCase() || 'M' }}</span>
        </button>
        <b class="member-sidebar-name">{{ isLoggedIn ? userName : '欢迎来到万博体育' }}<small v-if="isLoggedIn" class="member-vip-badge"><SiteIcon name="diamond" :size="12" />{{ memberDashboard?.levelName || '会员' }}</small></b>
        <span v-if="isLoggedIn && memberDashboard?.joinedDays != null">加入万博体育第{{ memberDashboard.joinedDays }}天</span><span v-else-if="isLoggedIn">会员中心</span><button v-else type="button" class="member-login" @click="openAuth('login')">登录后管理您的账户<span aria-hidden="true"> ›</span></button>
      </div>
      <div class="member-sidebar-finance">
        <button v-for="item in financeLinks" :key="item.path" :class="{ active: currentPath === item.path }" @click="navigate(item.path)">
          <ReferenceImage :image="item.image" /><span>{{ item.label }}</span>
        </button>
      </div>
      <nav>
        <button v-for="item in memberNavigation" :key="item.path" :class="{active:isActive(item.path),'member-nav-group-start':['/mine/finance/wallet','/mine/record/giftRecord'].includes(item.path)}" :aria-current="isActive(item.path) ? 'page' : undefined" @click="navigate(item.path)">
          <ReferenceImage class="member-nav-symbol" :image="memberArtwork[item.path]?.[isActive(item.path) ? 1 : 0]" />{{ item.label }}<span class="member-nav-chevron" aria-hidden="true">›</span>
        </button>
      </nav>
    </aside>
    <div class="member-content"><slot /></div>
    <FinanceRecordRail v-if="hasRightRail && isFinance" /><MemberRightRail v-else-if="hasRightRail" />
  </section>
</template>
<script setup>
import SiteIcon from '../SiteIcon.vue'
import ReferenceImage from '../ReferenceImage.vue'
import { memberArtwork } from '../../config/referencePresentation.js'
import MemberRightRail from './MemberRightRail.vue'
import FinanceRecordRail from './FinanceRecordRail.vue'
import { computed } from 'vue'
import { memberNavigation } from '../../config/navigation.js'
import { useAppContext } from '../../composables/appContext'
const { asset, currentPath, isLoggedIn, memberAvatarUrl, memberDashboard, openAuth, navigate, userName } = useAppContext()
const isActive = path=>path===currentPath.value || path==='/mine/vip' && (['/member/vip','/member/gift'].includes(currentPath.value) || currentPath.value.startsWith('/mine/vip/'))
const isFinance = computed(()=>/^\/mine\/finance\/(deposit|transfer|withdrawal)$/.test(currentPath.value))
const hasRightRail = computed(()=>['/member','/mine/finance/wallet'].includes(currentPath.value) || isFinance.value)
const financeLinks = [
  { label: '存款', path: '/mine/finance/deposit', image:17 },
  { label: '转账', path: '/mine/finance/transfer', image:19 },
  { label: '取款', path: '/mine/finance/withdrawal', image:21 },
]
const icons = { account: 'identification-card', vip: 'seal-check', gift: 'gift', wallet: 'money', rebate: 'arrow-circle-down', record: 'receipt', message: 'chats', help: 'question' }
</script>

<style scoped>
.member-login { min-height:44px; padding:8px; border:0; background:transparent; color:var(--kg-brand,#179cff); font:inherit; font-size:12px; cursor:pointer; }
.member-login:focus-visible { outline:2px solid var(--kg-brand,#179cff); outline-offset:2px; }
</style>
